import { useMutation } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import {
  CreateInvitationsRequest,
  CreateInvitationsResponse,
} from 'src/types/rest/managementPortalApi';

export const useCreateInvitations = () => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: CreateInvitationsRequest) =>
      apiRequest<CreateInvitationsResponse>({
        data: variables,
        method: 'POST',
        url: `${apiHost}/invitations`,
      }),
  });
};
